function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "cls-1",
  d: "M5.41,41.4v8.7c0,2,1.7,3.7,3.7,3.7v-16.1c-2,0-3.7,1.7-3.7,3.7"
}), React.createElement("path", {
  className: "cls-1",
  d: "M69.71,15.1c-2.7,0-4.8,2.2-4.8,4.8,0,2.2,1.5,4.1,3.6,4.7v29.1c2,0,3.7-1.7,3.7-3.7v-8.7c0-1.1-.4-2.1-1.2-2.8v-13.9c2.6-.7,4.1-3.3,3.4-5.9-.6-2.1-2.5-3.6-4.7-3.6"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M62.31,26.6H15.31c-2,0-3.7,1.6-3.7,3.7v30.9c0,2,1.7,3.7,3.7,3.7h47c2,0,3.7-1.7,3.7-3.7v-30.9c0-2-1.7-3.7-3.7-3.7ZM22.91,50.9h-2.5c0-4.1.3-5.6,2.1-7.9h-4.8v-2.5h7.6l.9,2.1c-3.1,3.3-3.3,3.8-3.3,8.3ZM31.41,61.2h-2.5v-30.9h2.5v30.9ZM40.21,50.9h-2.5c.1-4.1.4-5.6,2.2-7.9h-4.8v-2.5h7.5l.9,2.1c-3.1,3.3-3.3,3.8-3.3,8.3ZM48.71,61.2h-2.5v-30.9h2.5v30.9ZM57.51,50.9h-2.5c.1-4.1.4-5.6,2.2-7.9h-4.8v-2.5h7.5l.9,2.1c-3.1,3.3-3.3,3.8-3.3,8.3Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Slots-active.2e4ac9f5.svg";
export { SvgComponent as ReactComponent };